import React, { Component, Fragment } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { connect } from 'react-redux';
import Moment from 'moment';

import Text from '../../react-component/textComponent';

import Badge from '../../react-component/badge';

import styles from './styles';
import Colors from '../../config/Colors';

const dhFormat = 'YYYY-MM-DD HH:mm:ss';

const ID_STATUS_AGUARDANDO = 1;

class ItemLista extends Component {
    state = {
        elapsedTime: Moment().unix()
    };

    componentDidMount() {
        const { user, showOrderCounter = true } = this.props,
            { configLoja = {} } = user,
            { fgKds = false } = configLoja;

        if (fgKds && showOrderCounter) {
            this.getTimeCount();
        }
    }

    getItemStyle = (item) => {
        const { pedidoSelecionado } = this.props,
            { idPedido } = item,
            isSelected = pedidoSelecionado.idPedido === idPedido,
            selectedItemStyle = isSelected ? styles.selectedItem : null;

        return selectedItemStyle;
    };

    getTimeCount = () => {
        const { item, dhAtual } = this.props,
            { dhInclusao } = item,
            dhAtualStamp = Moment(dhAtual).unix(),
            dhInclusaoStamp = Moment(dhInclusao).unix();

        const elapsedTime = dhAtualStamp - dhInclusaoStamp;

        this.setState({ elapsedTime }, () => {
            this.startCounting();
        });
    };

    startCounting = () => {
        setInterval(this.countUp, 1000);
    };

    countUp = () => {
        this.setState(({ elapsedTime }) => ({ elapsedTime: elapsedTime + 1 }));
    };

    formatTimeCount = () => {
        const { elapsedTime } = this.state;

        const duration = parseInt(elapsedTime, 10),
            m = Moment.duration(duration, 'seconds').minutes(),
            s = Moment.duration(duration, 'seconds').seconds();

        const timeUnityPad = (num, size) => {
            var s = num + '';
            while (s.length < size) s = '0' + s;
            return s;
        };

        const minutes = timeUnityPad(m, 2),
            seconds = timeUnityPad(s, 2);

        let formatedTime = seconds + 's';

        if (elapsedTime >= 60) {
            formatedTime = minutes + ':' + seconds;
        }

        if (elapsedTime >= 3600) {
            formatedTime = '+ de 1h';
        }

        return formatedTime;
    };

    badgeColor = () => {
        const { elapsedTime } = this.state;

        let backgroundColor = { backgroundColor: Colors.danger };

        if (elapsedTime < 300) {
            backgroundColor = { backgroundColor: Colors.warning };
        }

        if (elapsedTime < 180) {
            backgroundColor = { backgroundColor: Colors.success };
        }

        return backgroundColor;
    };

    render() {
        const {
                item,
                showDetalhe,
                user,
                showOrderCounter = true,
                pedidoSelecionado,
                isHistorico = false
            } = this.props,
            { configLoja = {} } = user,
            { fgKds = false } = configLoja,
            {
                idPedido,
                dsUsuario,
                dsObservacao,
                dsConsumidorFinal,
                idStatusPedido
            } = item,
            hasMoreThenMax = dsObservacao
                ? dsObservacao.length > 30
                    ? ' . . .'
                    : ' '
                : dsConsumidorFinal
                  ? dsConsumidorFinal.length > 30
                      ? ' . . .'
                      : ' '
                  : '',
            observacaoKDS =
                (dsConsumidorFinal && dsConsumidorFinal.length > 30
                    ? dsConsumidorFinal
                          .replace(/[\r\n]+/g, ' ')
                          .substring(0, 27) + hasMoreThenMax
                    : dsConsumidorFinal) ||
                (dsObservacao
                    ? dsObservacao.replace(/[\r\n]+/g, ' ').substring(0, 27) +
                      hasMoreThenMax
                    : ' '),
            formatDataHora = (date) =>
                Moment(date, dhFormat).format('DD/MM - HH:mm'),
            dhEntregaRetirada = formatDataHora(item.dhEntregaRetirada),
            dhInclusao = formatDataHora(item.dhInclusao),
            novoPedido = idStatusPedido === ID_STATUS_AGUARDANDO,
            isSelected = pedidoSelecionado.idPedido === idPedido,
            itemStyle = this.getItemStyle(item);

        if (fgKds && showOrderCounter) {
            var badgeColor = this.badgeColor(),
                formatedOrderTime = this.formatTimeCount(),
                badgeContainer = [
                    styles.itemInfo,
                    styles.badgeContainer,
                    badgeColor
                ];
        }

        return (
            <Fragment>
                <TouchableOpacity
                    style={[styles.itemList, itemStyle]}
                    onPress={() => showDetalhe(item)}
                >
                    <View style={styles.lineContent}>
                        <Text
                            $bold={novoPedido && !isSelected ? 'true' : null}
                            style={styles.itemTitle}
                        >
                            #{idPedido}
                        </Text>
                        <View style={styles.itemInfo}>
                            <Text style={styles.itemInfoText}>
                                {fgKds ? dhInclusao : dhEntregaRetirada}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.lineContent}>
                        <View style={styles.itemInfo}>
                            {fgKds ? (
                                <Text style={styles.itemInfoText}>
                                    {observacaoKDS}
                                </Text>
                            ) : (
                                <Text style={styles.itemInfoText}>
                                    {dsUsuario}
                                </Text>
                            )}
                        </View>
                        {!isHistorico && fgKds && showOrderCounter && (
                            <Badge style={badgeContainer}>
                                <Text style={[styles.badgeText, badgeColor]}>
                                    {formatedOrderTime}
                                </Text>
                            </Badge>
                        )}
                    </View>
                </TouchableOpacity>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ pedidoSelecionado, pedidos, user }) => ({
    pedidoSelecionado,
    pedidos,
    user
});

export default connect(mapStateToProps, null)(ItemLista);
